import classNames from 'classnames'
import { ButtonProps } from 'lib/types'
import { ButtonStyles, ButtonSize } from 'lib/enums'
import spritemap from '@milestone-sys/web-design-system/msds-spritemap.svg'

const Button = ({
  id,
  label,
  href,
  size,
  styling,
  cssClass,
  tabIndex,
  icon,
  disabled,
  //eventCategory,
  //eventLabel,
  onClickHandler
}: ButtonProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    if (disabled) {
      e.preventDefault()
      return
    }
    onClickHandler?.()
  }

  const commonProps = {
    id,
    className: classNames(
      'msds-btn',
      size ? size : ButtonSize.Medium,
      styling ? styling : ButtonStyles.Primary,
      cssClass ? cssClass : '',
      disabled ? ButtonStyles.Disabled : ''
      //(eventCategory && eventLabel) ? "googlelinktracking" : ""
    ),
    onClick: handleClick,
    tabIndex: disabled ? -1 : tabIndex,
    'aria-disabled': disabled
    // "data-enable-google-event-tracking": (eventCategory && eventLabel) ? true : false,
    // "data-category": (eventCategory && eventLabel) ? eventCategory : "",
    // "data-label": (eventCategory && eventLabel) ? eventLabel : ""
  }

  const content = (
    <>
      {label}
      {icon && (
        <div className="msds-icon">
          <svg>
            <use href={spritemap + '#' + icon} />
          </svg>
        </div>
      )}
    </>
  )

  if (href && !disabled) {
    return (
      <a {...commonProps} href={href}>
        {content}
      </a>
    )
  }

  return (
    <button {...commonProps} type="button" disabled={disabled}>
      {content}
    </button>
  )
}

export default Button
